/**
 * Downloads content as a file.
 * @param {Array|Object} content - The content to download (JSON serializable).
 * @param {string} filename - The name of the file to be saved.
 */
export function downloadFile(content, filename, type = 'application/json') {
    if (!content || (Array.isArray(content) && content.length === 0)) {
      console.warn('No content available to download.');
      return;
    }
  
     // Handle JSON content
     if (type === 'application/json') {
      content = JSON.stringify(content, null, 2);  // Pretty print JSON
  }

    // Create the Blob with the correct content and type
    const blob = new Blob([content], { type });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  